/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The alarm state:
 *   * AUTOMATIC: automatic acknowledgement
 *   * MANUAL: manual acknowledgement
 */
export enum AcknowledgementOrigin {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}
